// Kinds of tasks (B32, B52): Klusjes to start with, more of PK's own. Ideas are Ooit.

import { useLiveQuery } from "dexie-react-hooks";
import { uuidv7 } from "@shared/uuid";
import { db, getMeta, type TaskCategory } from "./db";
import type { Me } from "./session";
import { sync } from "./sync";

export function useCategories(): TaskCategory[] | undefined {
  return useLiveQuery(async () =>
    (await db.task_categories.toArray())
      .filter((c) => !c.deleted_at)
      .sort((a, b) => a.position - b.position || a.name.localeCompare(b.name)),
  );
}

export async function saveCategory(id: string | null, name: string, position: number): Promise<string> {
  const categoryId = id ?? uuidv7();
  const me = await getMeta<Me>("me");
  const at = new Date().toISOString();
  await sync.mutate("category.save", { id: categoryId, name: name.trim(), position }, [categoryId], async () => {
    if (id) await db.task_categories.update(id, { name: name.trim(), position });
    else
      await db.task_categories.add({
        id: categoryId,
        space_id: me?.settings?.personal_space_id ?? "",
        user_id: me?.user.id ?? "",
        name: name.trim(),
        position,
        seed_key: null,
        version: 0,
        deleted_at: null,
        created_at: at,
        updated_at: at,
      });
  });
  return categoryId;
}

export async function removeCategory(id: string): Promise<void> {
  const at = new Date().toISOString();
  const tasks = (await db.tasks.toArray()).filter((t) => t.category_id === id);
  await sync.mutate("category.remove", { id, at }, [id, ...tasks.map((t) => t.id)], async () => {
    await db.task_categories.update(id, { deleted_at: at });
    for (const t of tasks) await db.tasks.update(t.id, { category_id: null });
  });
}
